import React from 'react'

import axios from 'axios'
import { baseUrl } from '../config/clientsConfig'

const EstimateService =  {
  
    getUnits : async (id) => {
        return axios.get(`${baseUrl}/units/getUnitsNo?docId=${id}`)
    }
}

export default EstimateService